export default __webpack_public_path__ + "static/media/slide2.6bc2ed6e.jpg";